import { Injectable } from '@angular/core';

/** 
 * Service to ferry data between the block interceptor and the block component wrapper. 
 */
@Injectable()
export class BlockUiService {

// #region [ Properties ]

	get HttpRequestResponseCounter(): number {
		return this.httpRequestResponseCounter; 
	} 

// #region [ Fields ]

	/**
	 * Flag indicating if the UI blocking should be overridden. Specifically used in cases of infinite scroll.
	 */
	public DoNotShowBlockUi: boolean = false;

	/**
	 * Running count of HTTP requests, fed from the BlockUiInterceptor.
	 */
	private httpRequestResponseCounter: number = 0; 

// #region [ Implemented Methods ]
	
	/**
	 * Increments the counter for http requests and responses by 1. 
	 */
	public IncrementCount(): void  {
		this.httpRequestResponseCounter++;
	}

	/**
	 * Decrements the counter for http requests and responses by 1. 
	 */
	public DecrementCount(): void  {
		if (this.HttpRequestResponseCounter > 0) {
	 		this.httpRequestResponseCounter--;
		}
	}

	/**
	 * Resets the counter for http requests and responses to 0.
	 */
	public ClearCounter(): void {
		this.httpRequestResponseCounter = 0;
	}

}

/**
 * I want my component to not block the UI. How do I do that? There are a few steps.
 * 
 *  - Inject the BlockUiService in your component.
 *  - Control the _BlockUiService.DoNotBlockUi boolean such that it's true when you want blocking overriden
 *  - The service will take care of any other resetting that needs to happen (abandoned HTTP calls or 
 * 		as-yet-unchanged overrides).
 */